import { cva } from "class-variance-authority";
import { cn } from "./utils.js";

/**
 * Alarm-limit proximity accents — independent of fleet asset status colors in
 * `status-utils.js`. Used when a trend is approaching (or in) an alarm band.
 *
 * Initial tints match brand-red status treatments so the UI stays consistent
 * today, but changing asset status colors must not change these (or vice versa).
 */
const ALARM_PROXIMITY_PILL = {
  approaching:
    "border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/10 dark:border-destructive/50 dark:bg-destructive/15 dark:text-red-300 dark:hover:bg-destructive/15",
};

const ALARM_PROXIMITY_DOT = {
  approaching: "bg-destructive",
};

/** Card/row wash when a measurement is approaching an alarm limit. */
export const ALARM_PROXIMITY_ROW = {
  surface: "border-destructive/40 bg-destructive/10 dark:border-destructive/50 dark:bg-destructive/15",
  hover: "hover:bg-destructive/15 dark:hover:bg-destructive/20",
};

const alarmProximityBadgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
  {
    variants: {
      kind: {
        approaching: ALARM_PROXIMITY_PILL.approaching,
      },
    },
  }
);

const alarmProximityDotVariants = cva(
  "inline-block h-2 w-2 shrink-0 rounded-full",
  {
    variants: {
      kind: {
        approaching: ALARM_PROXIMITY_DOT.approaching,
      },
    },
  }
);

/**
 * Pill surface for alarm-limit proximity flags (e.g. "threshold").
 * @param {"approaching"} [kind="approaching"]
 * @param {string} [className]
 * @returns {string}
 */
export function getAlarmProximityBadgeClass(kind = "approaching", className) {
  return cn(alarmProximityBadgeVariants({ kind }), className);
}

/**
 * Dot for alarm-limit proximity flags.
 * @param {"approaching"} [kind="approaching"]
 * @param {string} [className]
 * @returns {string}
 */
export function getAlarmProximityDotClass(kind = "approaching", className) {
  return cn(alarmProximityDotVariants({ kind }), className);
}
